module.exports = __webpack_public_path__ + "static/media/retail-property-grid-1.2eee6c35.jpeg";